import Server from './server';
import Music from './modules/music';

const extendApis = { ...Music };

class API extends Server {
    // <!!-------铛铛留言系统相关接口-------!!>

    async msgList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/shamreply/msg/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async messageList(params = {}) { //获取消息列表
        try {
            let result = await this.axios('get', '/u2/console/shamreply/his/msg/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async sendMsg(params = {}) { //回复留言接口
        try {
            let result = await this.axios('get', '/u2/console/shamreply/send/msg', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async loginAuthentication(params = {}) {  // 登陆接口
        try {
            let result = await this.axios('get', '/u2/console/login', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }



    // <!!-------铛铛添加通用自定义公开信息相关接口-------!!>



    async getFuncList(params = {}) { //获取公开信息列表
        try {
            let result = await this.axios('get', '/u2/console/display/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async getCircleList(params = {}) { //获取公众圈列表
        try {
            let result = await this.axios('get', '/u2/console/display/circleList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getOpenInfoDetail(params = {}) { //获取公开信息详情
        try {
            let result = await this.axios('get', '/u2/console/display/detail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async deleteFunction(params = {}) { //删除公众圈功能
        try {
            let result = await this.axios('get', '/u2/console/display/deleteFunction', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async deleteDisplay(params = {}) { //删除展示信息
        try {
            let result = await this.axios('get', '/u2/console/display/deleteDisplay', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async addFunction(params = {}) {  //增加功能
        try {
            let result = await this.axios('post', '/u2/console/display/operateFunction', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    async addOpenInfo(params = {}) {  //增加公开信息
        let data = JSON.stringify(params);
        try {
            let result = await this.axios('post', '/u2/console/display/addDisplay', {
                data,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    // <!!-------优惠券相关接口-------!!>


    async getCaissaOrderList(params = {}) {  //凯撒旅游订单获取
        try {
            let result = await this.axios('post', '/u2/console/order/caissaOrderList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    // 核销登陆验证
    async playConsumeLogin(params = {}) {
        try {
            let result = await this.axios('post', '/promotion/v1/playConsume/login', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    //核销总览列表
    async getOverviewList(params = {}) {
        try {
            let result = await this.axios('post', '/promotion/v1/playConsume/consumeCount', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    // 欢乐路途-详情查询
    async getPlayConsumeConsumeQueryApi(params = {}) {
        try {
            let result = await this.axios('post', '/promotion/v1/playConsume/consumeQuery', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    // 百程俱乐部数据查询系统
    async getBaichengDataList(params = {}) {
        try {
            let result = await this.axios('get', '/promotion/v1/baicheng/order/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async baichengRepush(params = {}) { //向铛铛用户再发一次通知
        try {
            let result = await this.axios('get', '/promotion/v1/baicheng/order/repush', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async baichengOrderConversion(params = {}) { //百城用户统计
        try {
            let result = await this.axios('get', '/promotion/v1/baicheng/order/conversion', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getUserFromCensus(params = {}) { //铛铛用户来源统计
        try {
            let result = await this.axios('get', '/u2/console/user/source', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    // 天天乐发布活动相关

    async syncPic(params = {}) { //图片信息
        try {
            let result = await this.axios('get', '/promotion/oss/image/info', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async syncVideo(params = {}) { //视频信息
        try {
            let result = await this.axios('get', '/cp/album/videoFrame', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getObjectTypeList(params = {}) { //获取社区类型
        try {
            let result = await this.axios('get', '/u2/v1.1/manage/specialList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async publishActivity(params = {}) { //发布活动
        // let data=JSON.stringify(params);
        try {
            let result = await this.axios('post', '/u2/v1.1/manage/activity', {
                // data,
                // headers:{
                //     'Content-Type':"application/json"
                // }
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async publishRules(params = {}) { // 发布规则
        let data = JSON.stringify(params);
        try {
            let result = await this.axios('post', '/u2/v1.1/manage/hbActivity', {
                data,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getActivityDetail(params = {}) { //获取活动类型
        try {
            let result = await this.axios('post', '/u2/v1.1/manage/hbDetail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getLiveList(params = {}) { //直播列表
        try {
            let result = await this.axios('get', '/u2/console/show/live/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getLiveAuthList(params = {}) { //实名列表
        try {
            let result = await this.axios('get', '/u2/console/show/live/authList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getLiveFreezeList(params = {}) { //封禁列表
        try {
            let result = await this.axios('get', '/u2/console/show/live/freezeList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getLiveRewardList(params = {}) { //打赏记录
        try {
            let result = await this.axios('get', '/u2/console/show/live/rewardList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async getLiveRecGoodsList(params = {}) { //带货记录
        try {
            let result = await this.axios('get', '/u2/console/show/live/recGoodsList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async liveCheck(params = {}) { //后台实名列表 审核
        try {
            let result = await this.axios('get', '/u2/console/show/live/check', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async liveUnfreeze(params = {}) { //后台 直播解封
        try {
            let result = await this.axios('get', '/u2/console/show/live/unfreeze', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async liveFreeze(params = {}) { //后台 直播封禁
        try {
            let result = await this.axios('get', '/u2/console/show/live/freeze', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async playList(params = {}) { //后台 推广活动列表
        try {
            let result = await this.axios('get', '/u2/console/play/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async playAdd(params = {}) { //后台 推广活动添加
        try {
            let result = await this.axios('get', '/u2/console/play/add', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async playDetail(params = {}) { //后台 推广活动详情
        try {
            let result = await this.axios('get', '/u2/console/play/detail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    // <!!-------敏感词相关接口-------!!>

    async addSW(params = {}) { // 添加更新敏感词
        try {
            let result = await this.axios('get', '/u2/console/circle/sw/add', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async SWList(params = {}) { // 管理敏感词查看列表
        try {
            let result = await this.axios('get', '/u2/console/circle/sw/swList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    async SWMainList(params = {}) { // 敏感词被封用户列表
        try {
            let result = await this.axios('get', '/u2/console/circle/sw/mainList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }



    async SWSourceDetail(params = {}) { // 敏感词被封用户详情
        try {
            let result = await this.axios('get', '/u2/console/circle/sw/sourceDetail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    async SWRemove(params = {}) { // 移除某个用户
        try {
            let result = await this.axios('get', '/u2/console/circle/sw/remove', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async addUser(params = {}) { // 
        let data = JSON.stringify(params);
        try {
            let result = await this.axios('post', '/u2/console/circle/sw/addUser', {
                data,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async getUser(params = {}) { // 
        try {
            let result = await this.axios('get', '/u2/console/circle/sw/getUser', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async swMessageAdd(params = {}) { // 
        let data = JSON.stringify(params);
        try {
            let result = await this.axios('post', '/sw/swMessage/add', {
                data,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async swMessageSwList(params = {}) { // 
        try {
            let result = await this.axios('post', '/sw/swMessage/swList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async swMessageMainList(params = {}) { // 
        try {
            let result = await this.axios('get', '/sw/swMessage/mainList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async swMessageDetailList(params = {}) { // 
        try {
            let result = await this.axios('get', '/sw/swMessage/detailList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async swMessageFrozen(params = {}) { // 
        try {
            let result = await this.axios('get', '/sw/swMessage/frozen', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async swMessageDismiss(params = {}) { // 
        try {
            let result = await this.axios('get', '/sw/swMessage/dismiss', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }



    // <!!-------寻宝规则-------!!>

    async ruleDetail(params = {}) { // 
        try {
            let result = await this.axios('get', '/u2/console/prize/rule/item/detail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async ruleEdit(params = {}) { // 
        try {
            let result = await this.axios('get', '/u2/console/prize/rule/item/edit', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    // <!!-------主题飞行 -- 消费券-------!!>
    async couponMainShopList(params = {}) { // 
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/mainShopList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async getSignatureAndPolicy(params = {}) { // 
        try {
            let result = await this.axios('get', '/promotion/oss/policy', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponAddShop(params = {}) { // 添加商家
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/addShop', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponEditShop(params = {}) { // 添加商家
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/editShop', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponShopDetail(params = {}) { // 商家详情
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/shopDetail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async couponEditBrandCard(params = {}) { // 商家详情
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/editBrandCard', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponDeleteShop(params = {}) { // 删除商家
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/deleteShop', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }



    async couponQueryCardList(params = {}) { // 卡号添加
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/queryCardList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    async couponAddCard(params = {}) { // 卡号添加
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/addCard', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponDeleteCard(params = {}) { // 卡号删除
        try {
            let result = await this.axios('get', '/promotion/v1/console/coupon/deleteCard', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponConsumeStat(params = {}) { // 核销统计
        try {
            let result = await this.axios('get', '/u2/v1/console/coupon/consumeStat', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponConsumeStatExport(params = {}) { // 核销统计
        try {
            let result = await this.axios('get', '/console/v1/themeflight/consumeStat/export', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    // <!!-------导览统计-------!!>


    async greatWallQrType(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/circle/greatWall/qrType', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async greatWallGuide(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/circle/greatWall/guide', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async greatWallClickBanner(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/circle/greatWall/clickBanner', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    async greatWallLottery(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/circle/greatWall/lottery', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async topTenCrewCount(params = {}) {
        try {
            let result = await this.axios('get', '/promotion/v1/topTen/crewCount', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    // <!!-------发布优惠券-------!!>

    async couponEdit(params = {}) {
        try {
            let result = await this.axios('post', '/u2/v1/coupon/template/edit', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async couponDetail(params = {}) {
        try {
            let result = await this.axios('get', '/u2/v1/coupon/template/detail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    // <!!-------竞猜活动-------!!>

    async winnerModuleEdit(params = {}) {
        try {
            let result = await this.axios('post', '/u2/console/play/winner/module/edit', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async winnerModuleDetail(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/winner/module/detail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    // <!!-------直播抽奖-------!!>
    async phaseEdit(params = {}) {
        try {
            let result = await this.axios('post', '/u2/console/monthLottery/phaseEdit', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async phaseDelete(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/monthLottery/phaseDelete', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async phaseList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/monthLottery/phaseList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async prizeDelete(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/monthLottery/prizeDelete', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async phaseLotteryAction(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/monthLottery/phaseLotteryAction', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async startLottery(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/monthLottery/startLottery', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async submitLotteryNum(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/monthLottery/submitLotteryNum', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async queryPushUrl(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/monthLottery/queryPushUrl', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    // <!!-------财务提现-------!!>

    async tradeStatus(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/pay/trade/status', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async transferList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/pay/trade/transferList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async transferCsv(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/pay/trade/transferCsv', {
                params,
                responseType: 'blob',
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    // <!!-------音乐公众圈-------!!>

    async musicCircleList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/music/circleList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async musicFunctionList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/music/functionList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async musicEditCircle(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/music/editCircle', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async musicCircleDetail(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/music/circleDetail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async thdCheckList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/thd/checkList', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async thdMatch(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/thd/match', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async thdList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/thd/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }


    async memberList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/thd/member/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async thdSign(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/thd/sign', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async thdRemark(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/thd/remark', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }

    async cardTemplateList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/card/template/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async cardTemplateDelete(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/card/template/delete', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async cardUserList(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/card/user/list', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async cardTemplateDetail(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/card/template/detail', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async cardTemplateAdd(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/card/template/add', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async cardTemplateEdit(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/card/template/edit', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
    async playThdAudit(params = {}) {
        try {
            let result = await this.axios('get', '/u2/console/play/thd/audit', {
                params
            });
            if (result)
                return result
        } catch (err) {
            throw err
        }
    }
}

Object.assign(API.prototype, extendApis);
export default new API()